import * as React from 'react';
import { colors } from '../styles/colors';

interface IProps {
    isCancel?: boolean;
    onClick(): void;
    buttonText: string;
    fontStyle?: React.CSSProperties;
    isDisabled?: boolean;
    buttonStyle?: React.CSSProperties;
}

export class ModalActionButton extends React.Component<IProps> {
    //TODO: Add hover and on-press animations to this component
    public render() {
        const isDisabledStyle = this.props.isDisabled ? { opacity: 0.3 } : {};
        const containerStyle = { ...styles.defaultContainer };

        return (
            <button style={{ ...styles.container, ...containerStyle, ...isDisabledStyle, ...this.props.buttonStyle }} onClick={() => this.props.onClick()}>
                <span className="unselectable" style={{ ...styles.buttonText, ...this.props.fontStyle, ...(this.props.isCancel ? { color: colors.CANCEL_TEXT } : {}) }}>
                    {this.props.buttonText}
                </span>
            </button>
        );
    }
}

const styles = {
    defaultContainer: {
        width: 175,
        height: 55
    },
    container: {
        borderRadius: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FBE3E6',
        outline: 'none',
        cursor: 'pointer',
        border: 'none'
    } as React.CSSProperties,
    buttonText: {
        color: '#444648',
        fontSize: 20,
        fontWeight: 800,
        textAlign: 'center'
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/SharedComponents/ModalActionButton.tsx